import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const CATS = [
  { key: "punk", label: "Punk" },
  { key: "sports", label: "Sports" },
  { key: "fitness", label: "Fitness" },
  { key: "street", label: "Street Gear" },
  { key: "print", label: "Prints" },
];
const TYPES = [
  { key: "tshirt", label: "T-Shirts" },
  { key: "print", label: "Prints" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const category = params.get("category") || "";
  const type = params.get("type") || "";

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (category) q.category = category;
    if (type) q.type = type;
    api.get("/products", { params: q }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [category, type]);

  const setFilter = (key, val) => {
    const next = new URLSearchParams(params);
    if (next.get(key) === val) next.delete(key);
    else next.set(key, val);
    setParams(next);
  };

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-12 md:py-16" data-testid="shop-page">
      <h1 className="font-anton text-5xl md:text-7xl uppercase tracking-tighter mb-2">The Catalog</h1>
      <p className="font-mono text-sm text-muted-foreground mb-8">{products.length} items in the drop</p>

      <div className="flex flex-wrap gap-3 mb-10 border-y-2 border-border py-5">
        <span className="font-outfit font-bold uppercase text-xs tracking-widest self-center mr-2">Type:</span>
        {TYPES.map((t) => (
          <button
            key={t.key}
            data-testid={`filter-type-${t.key}`}
            onClick={() => setFilter("type", t.key)}
            className={`font-outfit font-bold uppercase text-xs tracking-widest px-4 py-2 border-2 border-border transition-colors ${type === t.key ? "bg-primary text-primary-foreground border-primary" : "bg-card hover:bg-primary hover:text-black"}`}
          >
            {t.label}
          </button>
        ))}
        <span className="font-outfit font-bold uppercase text-xs tracking-widest self-center mx-2 md:ml-6">Vibe:</span>
        {CATS.map((c) => (
          <button
            key={c.key}
            data-testid={`filter-category-${c.key}`}
            onClick={() => (c.key === "print" ? setFilter("type", "print") : setFilter("category", c.key))}
            className={`font-outfit font-bold uppercase text-xs tracking-widest px-4 py-2 border-2 border-border transition-colors ${(c.key === "print" ? type === "print" : category === c.key) ? "bg-primary text-primary-foreground border-primary" : "bg-card hover:bg-primary hover:text-black"}`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="font-mono text-sm animate-pulse">Loading gear<span className="animate-ping">_</span></p>
      ) : products.length === 0 ? (
        <p className="font-mono text-sm" data-testid="shop-empty">No items match. Reset your filters.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-black border border-border">
          {products.map((p) => (
            <div key={p.id} className="bg-card">
              <ProductCard product={p} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
